export default __webpack_public_path__ + "static/media/mootools.381ab225.svg";